<script setup lang="ts">
/**
 * UI-kit component
 * Category: Headers
 * Name: HeaderLinkList
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=4202-18717
 *
 * One column of a header menu block: an optional clickable subtitle (DS Link,
 * size lg — shown only when the column is a branch of a set, e.g. Elementary /
 * Middle School / High School) above a stack of HeaderLinks (gap space/2).
 * Width is unconstrained — the column grows with its longest link.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui.
 */
// types
import type { HeaderLinkListProps } from '../types/interfaces'
// components
import { Link } from '@brighterly/lib-lumee-ui'

defineOptions({
  name: 'HeaderLinkList',
})

withDefaults(defineProps<HeaderLinkListProps>(), {
  subtitle: '',
  subtitleUrl: '',
})
</script>

<template>
  <div class="header-link-list">
    <div
      v-if="subtitle"
      class="header-link-list__subtitle"
    >
      <Link
        color="primary"
        size="lg"
        padding="none"
        :href="subtitleUrl"
      >{{ subtitle }}</Link>
    </div>
    <div class="header-link-list__content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_header-link-list.scss" />
